import { TRIGGER_SIGN_AGREEMENT_API, TRIGGER_SIGN_AGREEMENT_API_SUCCESS } from 'redux/actionTypes';

export function triggerSignAgreementApiCall(callback) {
	return {
		type: TRIGGER_SIGN_AGREEMENT_API,
		callback,
	};
}

export function triggerSignAgreementApiCallSuccess(data) {
	return {
		type: TRIGGER_SIGN_AGREEMENT_API_SUCCESS,
		data,
	};
}
